package com.devi3east.bashbuddy.cart.navigation

import androidx.navigation.NavGraphBuilder
import androidx.navigation.NavType
import androidx.navigation.compose.composable
import androidx.navigation.navArgument
import androidx.navigation.navDeepLink
import androidx.savedstate.read
import com.devi3east.bashbuddy.cart.ui.StripeSuccessScreen
import com.devi3east.bashbuddy.features.app.data.AppState
import com.devi3east.bashbuddy.features.app.data.Screen

const val STRIPE_SESSION_ID_ARG = "sessionId"
const val STRIPE_ORG_ID_ARG = "orgId"

fun NavGraphBuilder.stripeSuccessNavGraph(
    appState: AppState
) {
    composable(
        route = Screen.StripeSuccessScreen.route,
        arguments = listOf(
            navArgument(STRIPE_SESSION_ID_ARG) {
                type = NavType.StringType
                nullable = false
            },
            navArgument(STRIPE_ORG_ID_ARG) {
                type = NavType.StringType
                nullable = false
            }
        ),
        deepLinks = listOf(
            navDeepLink {
                uriPattern =
                    "https://bash-buddy.com/stripe/success?" +
                            "session_id={$STRIPE_SESSION_ID_ARG}&" +
                            "org_id={$STRIPE_ORG_ID_ARG}"
            }
        )
    ) { backStackEntry ->

        val args = backStackEntry.arguments ?: return@composable

        val sessionId = args.read {
            getString(STRIPE_SESSION_ID_ARG)
        }

        val orgId = args.read {
            getString(STRIPE_ORG_ID_ARG)
        }

        StripeSuccessScreen(
            appState = appState,
            sessionId = sessionId,
            orgId = orgId
        )
    }
}